export const pinterestFollowMetaData = {
    isRepeatable: false
}
